import React, { Component } from 'react';
import config from 'config/api'
import { Link } from 'react-router-dom';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLegal: false,
    }
  }
  componentDidMount() {
  }
  _legalToggle() {
    this.setState({ showLegal: !this.state.showLegal }, function () {
      const top = document.getElementById('footer') ? document.getElementById('footer').offsetTop : false
      window.scroll({
        top,
        behavior: 'smooth'
      })
    });
  }
  render() {
    const { showLegal } = this.state;
    const ml = 'contact__lobster-fr*com'.replace('__', '@').replace('*', '.');
    const mlt = ('mail::to:' + ml).replace('::', '');
    return (
      <div id="footer" className="Footer">
        <div className="top">
          <div className="cell">
            <span>Lobst<em className="gold">e</em>r</span> <em className="dash">-</em>
            <span><em className="gold">140 bis rue de Rennes 75006 PARIS</em></span>
            <em className="dash">-</em>
            <span>01 59 51 07 02</span>
            <em className="dash">-</em>
            <span><a className="gold" href={mlt}>{ml}</a></span>
            <em className="dash">-</em>
            <span className="links"><a className="social" href={config.fb} target="_blank"><img src={require('@assets/images/icon_facebook.jpg')} alt="Facebook" /></a> <a className="social" href={config.ld} target="_blank"><img src={require('@assets/images/icon_linkedin.jpg')} alt="Linkedin" /></a></span> <em className="dash break">-</em>

          </div>
          <div className="cell">
            <span><Link to={'/confidentialite'} className="gold">Politique de Confidentialité</Link></span><em className="dash">-</em>
            <span><a className="gold" onClick={this._legalToggle.bind(this)}>Mentions Légales</a></span>
          </div>
        </div>
        <div className="content">
          <If condition={showLegal}>
            <div className={"wrapper"}>
              <span className="title">MENTIONS LEGALES</span>
              lobster-fr.com est édité par la société Lobster
              <span className="spacer"></span>
              <div className="dualTable">
                <span className="left">
                  Lobster<br />
                  <br />
                  Société lobster<br />140 bis rue de Rennes 75006 PARIS – France<br />SARL au capital de 50 000 €<br />RCS Nanterre 520 504 614<br />APE 7022Z<br />TVA FR 94520504614
                </span>
                <span className="right">
                  Hébergeur<br />
                  <br />
                  Ce site est hébergé par OVH<br />2 rue kellermann BP 80157 - 59053 Roubaix Cedex 1 - France<br />SAS au capital de 10 059 500 € <br />RCS Lille 424 761 419<br />APE 2620Z <br />TVA FR22424761419
                </span>
              </div>
              <p>Tél. : 01 59 51 07 02 - Mail : <a href={mlt}>{ml}</a> - Représentants Légaux : Dimitri Morlet, Cyril Eaton -  Directeur de la Publication : Dimitri Morlet</p>
              <span className="spacer"></span>
              <p><strong>Confidentialité et Protection des Données</strong><br /><br />
                Les sites de la société Lobster sont enregistrés auprès de la Commission Nationale de l'Informatique et des Libertés. Conformément à la loi informatique et libertés du 06 janvier 1978, vous pouvez à tout moment modifier ou supprimer les renseignements liés à votre inscription. Ces informations vous concernant étant confidentielles, Lobster s'engage à les protéger.<br />Vous disposez d'un droit d'accès, de modification, de rectification et de suppression des données qui vous concernent (art. 34 de la loi "Informatique et Libertés").<br />Vous pouvez exercer ce droit en nous contactant par mail ou par téléphone.<br />Pour plus d'informations, vous pouvez consulter le site de la CNIL : http://www.cnil.fr
              </p>
            </div>
          </If>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx